import './index.scss';

import { useTrackersData } from 'pages/Trackers/trackersProvider';
import React from 'react';

import ProductContainer from './productContainer';
import ProjectContainer from './projectContainer';

export default function PageContent() {
  const { renderGroups, productLineItems } = useTrackersData();

  if (!(renderGroups.length > 0) && !(productLineItems?.length > 0)) {
    return (
      <p className="noOrders">
        <span className="circle" />
        <span className="text">No orders</span>
      </p>
    );
  }

  return (
    <div>
      <ol className="projects">
        {/* Render product-type line items in a flat list at the top level */}
        {(productLineItems || []).map((product) => (
          <ProductContainer
            key={product.lineItemId}
            product={product}
          />
        ))}
        {/* Then render project-based trackers below */}
        {renderGroups.map(({
          projectId, orgId, trees,
        }) => (
          <ProjectContainer
            key={`${projectId}-${trees[0]?.[0]?.[0]?.uniqueId}`}
            projectId={projectId}
            orgId={orgId}
            treesData={trees}
          />
        ))}
      </ol>
    </div>
  );
}
